/** Trailing slashes stripped. Empty when unset (use same origin / Vite proxy). */
export function apiOrigin(): string {
    const v = import.meta.env.VITE_API_ORIGIN?.trim();
    return v ? v.replace(/\/$/, "") : "";
}

export function apiUrl(path: string): string {
    const p = path.startsWith("/") ? path : `/${path}`;
    const o = apiOrigin();
    return o ? `${o}${p}` : p;
}
